/* Image Gallery */
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';

export default (el) => {
    let pswpDomEl = document.querySelector('.pswp');
    let items = el.children;
    let slidesArray = [];
    let options = {
        index: 0,
        escKey: true,
        // // Zoom effect:
        getThumbBoundsFn: function (index) {
            let thumbnail = items[index].getElementsByTagName('img')[0], // find thumbnail
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();

            return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
        },
        captionEl: true,

        // Function builds caption markup
        addCaptionHTMLFn: function(item, captionEl, isFake) {
            if (!item.title) {
                captionEl.children[0].innerHTML = '';
                return false;
            }
            captionEl.children[0].innerHTML = item.title;
            return true;
        }
    };

    /*
     * Photoswipe needs an array with at least the following items:
     * src: 'path/to/image1.jpg',
     * w: 1024, // image width
     * h: 768, // image height
     */

    for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let itemSrc = item.querySelector('a').getAttribute('href'),
            itemImg = item.querySelector('img').getAttribute('src'),
            itemSize = item.querySelector('a').dataset.size;

        let slide = {
            src: itemSrc,
            w: itemSize.split('x')[0], // split data-size="1024x768" to w and h
            h: itemSize.split('x')[1],
            msrc: itemImg,
            title: item.querySelector('a').getAttribute('title'),
        };

        slidesArray.push(slide);

        item.querySelector('a').addEventListener('click', function (i, event) {
            event.preventDefault();
            options.index = i;
            openPhotoSwipe();
        }.bind(this, i));
    }

    function openPhotoSwipe() {
        let gallery = new PhotoSwipe(pswpDomEl, PhotoSwipeUIDefault, slidesArray, options);
        gallery.init();
    }
};
